export const resolveCurrentIframeSrc = ({
  currentWindowPath
}: {
  fallbackWindowUrl: string
  currentWindowPath: string
  isContainerBridgeAvailable: boolean
}) => currentWindowPath

export const resolveMountedIframeSrc = ({
  mountedSrc,
  nextRequestedSrc
}: {
  mountedSrc?: string
  nextRequestedSrc: string
}) => mountedSrc ?? nextRequestedSrc
